import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { EvaluationINV1, ImportationOfInventories, Inventory, InventoryDetailsSchedule, InventoryReportArboreal, InventoryScheduleMap } from '../models/Inventory'
import { Address } from '../models/Address'
import * as FileSaver from 'file-saver'
import { InventoryDtoScheduling } from '../components/protected/scheduler-inventory/pre-schedule/dto/inventory-pre-scheduling.dto'
import { QuestionsFilters } from '../models/DetailsFromClick'

@Injectable()
export class InventoryService {
	public notificationService: any
	constructor(private http: HttpClient) { }

	public syncInventoryTree(linksToS3Inventories: Array<string>, observationImport: string, companyId: string): Observable<string> {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/inventorys/syncInventoryTrees`,
			{
				linksToS3Inventories,
				observationImport,
				companyId
			}, {
			headers: options
		}
		)
			.pipe(
				map(res => {
					return res.message
				})
			)
	}

	public removeToPageSchedule(inventoryId: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.delete<any>(`${PATH}/inventorys/removeToSchedule/${inventoryId}`,
				{ headers: options }
			)
	}
	public getQuestionStateTree(companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/questions/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public fetchImportationOfInventories(companyId: string): Observable<Array<ImportationOfInventories>> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/importations/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public removeImportation(id: number): Observable<string> {
		const options: any = this.setHeader()

		return this.http
			.delete<any>(`${PATH}/inventorys/importations/${id}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.message
				})
			)
	}

	public getInventorySchedule(
		companyId: string,
		skip: any,
		limit: any,
		order: any,
		typeOrder: any,
		filterText: any,
		status: any): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/all?companyId=${companyId}&skip=${skip}&limit=${limit}&order=${order}&typeOrder=${typeOrder}&search=${filterText}&status=${status}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getOnlySelectedInventories(companyId: string, itensSelected: Array<string>, skip: number, limit: number, orderBy: string, typeOrder: string) {
		const options = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/all?companyId=${companyId}&onlySelected=true&itensSelected=${itensSelected.join(',')}&skip=${skip}&limit=${limit}&order=${orderBy}&typeOrder=${typeOrder}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getHandlerOperations(companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/app/handlerOperation/list/${companyId}/inventor`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getUserEmails(companyId: string): Observable<Array<string>> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/user/listEmails/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getInventoryHistoryCompany(companyId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/history/company/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getExportInventorysHistory(companyId: string, dateStart?: number, dateEnd?: number, roles?: Array<string>): Observable<Inventory> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/history/all?companyId=${companyId}&dateStart=${dateStart}&dateEnd=${dateEnd}&role=${roles}`, {
				headers: options
			})
			.pipe(
				map(result => {
					const stringBase64 = result.content

					if (stringBase64 == undefined) {
						return this.notificationService.notify('Não há dados a serem exportados', 420)
					}
					// Decodificar a string Base64 para um array de bytes
					const byteCharacters = atob(stringBase64)
					const byteNumbers = new Array(byteCharacters.length)

					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i)
					}

					const byteArray = new Uint8Array(byteNumbers)

					const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

					// Realizar o download do arquivo automaticamente
					FileSaver.saveAs(blob, `Relatório_de_histórico_de_inventário_export_${new Date().getTime()}.xlsx`)
				})
			)
	}

	public getExportInventorysSchedule(companyId: string, dateStart?: number, dateEnd?: number, roles?: Array<string>): Observable<Inventory> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/schedule/all?companyId=${companyId}&dateStart=${dateStart}&dateEnd=${dateEnd}&role=${roles}`, {
				headers: options
			})
			.pipe(
				map(result => {
					const stringBase64 = result.content

					if (stringBase64 == undefined) {
						return this.notificationService.notify('Não há dados a serem exportados', 420)
					}
					// Decodificar a string Base64 para um array de bytes
					const byteCharacters = atob(stringBase64)
					const byteNumbers = new Array(byteCharacters.length)

					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i)
					}

					const byteArray = new Uint8Array(byteNumbers)

					const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

					// Realizar o download do arquivo automaticamente
					FileSaver.saveAs(blob, `Relatório_de_agendamento_de_inventário_export_${new Date().getTime()}.xlsx`)
				})
			)
	}

	public cancelScheduleForAppraisal(inventoryId: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.delete<any>(`${PATH}/inventorys/${inventoryId}`, {
				headers: options
			})
	}

	public cancelScheduleForOperation(
		operationId: string,
		justifyCancel: string
	): Observable<any> {
		return this.http.patch<any>(
			`${PATH}/operationService/scheduling/${operationId}`,
			{ justification: justifyCancel },
			{ headers: this.setHeader() }
		)
	}

	public getClickTree(inventoryId: string, companyId: string): Observable<any> {
		const options = this.setHeader()
		return this.http.get<any>(`${PATH}/inventorys/getClick/${inventoryId}/${companyId}`, {
			headers: options
		}).pipe(
			map(result => {
				return result.content
			}
			))
	}

	public updateLocationPinMapHistory(inventoryId: string, location: Address): Observable<Inventory> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/inventorys/maps/updatePin/${inventoryId}`, JSON.stringify(location), {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}


	public inactiveInventory(inventoryId: string): Observable<Inventory> {
		const options: any = this.setHeader()

		return this.http
			.delete<any>(`${PATH}/inventorys/inactivateInventory/${inventoryId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}
	public reactivateInventory(inventoryId: string): Observable<Inventory> {
		const options: any = this.setHeader()

		return this.http
			.put<any>(`${PATH}/inventorys/reactivateInventory/${inventoryId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}
	public updateMapCache(companyId: string, userEmail: string): Observable<Array<Inventory>> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/inventorys/${companyId}/${userEmail}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getInventoryDetails(idMongo: string): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/inventory-details/${idMongo}`, {
				headers: options
			}).pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updateInventory(body: InventoryDetailsSchedule): Observable<any> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/inventorys/updateInventory`, body, {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public getInventoryReportArboreal(
		inventoryIds: string
	): Observable<Array<InventoryReportArboreal>> {
		const options: any = this.setHeader()

		return this.http
			.get<any>(`${PATH}/inventorys/inventoryReportArboreal/${inventoryIds}`,
				{
					headers: options
				})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updateInventoryReportArboreal(inventories: Array<InventoryReportArboreal>, inventoryId: string): Observable<string> {
		const options: any = this.setHeader()

		console.log(inventories)

		return this.http.patch<any>(`${PATH}/inventorys/inventoryReportArboreal`,
			{
				inventoriesReport: inventories
			},
			{ headers: options }
		).pipe(
			map(result => {
				return result.message
			})
		)
	}

	public updateInventoriesFromScheduler(inventoriesModified: Array<InventoryDtoScheduling>) {
		const options: any = this.setHeader()
		const companyId = localStorage.getItem('companyId')

		return this.http.patch<any>(`${PATH}/inventorys/scheduler/update/inventories/${companyId}`,
			inventoriesModified
			, {
				headers: options
			})
	}

	public findFirstInv1ForCompany(companyId: string): Observable<EvaluationINV1> {
		const options: any = this.setHeader()

		return this.http.get<any>(`${PATH}/evaluation/inv1/${companyId}`, { headers: options }).pipe(
			map(result => {
				return result.content
			})
		)
	}

	public sendToOperationSchedule(
		companyId: string,
		companyProviderId: string,
		inventoryIds: Array<string>
	): Observable<string> {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/operationService/scheduling/create-operation-from-inventory`,
			{
				companyId,
				companyProviderId ,
				inventoryIds
			}, {
			headers: options
		}
		)
			.pipe(
				map(res => {
					return res.message
				})
			)
	}

	public getInventoryScheduleMap(companyId: string): Observable<Array<InventoryScheduleMap>> {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/inventorys/scheduleMap/${companyId}`, { headers: options })
			.pipe(
				map(res => {
					return res.schedulePins
				})
			)
	}

	public getInventoryScheduleMapFilters(companyId: string): Observable<QuestionsFilters> {
		const options: HttpHeaders = this.setHeader()

		return this.http.get<any>(`${PATH}/inventorys/scheduleMap/mapFilter/${companyId}`, { headers: options })
			.pipe(
				map(res => {
					return res.filters
				})
			)
	}

	public getScheduleTreeInfos(inventoryId: string, companyId: string): Observable<any> {
		const options = this.setHeader()
		return this.http.get<any>(`${PATH}/inventorys/getScheduleClick/${inventoryId}/${companyId}`, {
			headers: options
		}).pipe(
			map(result => {
				return result.content
			}
			))
	}

	public updateScheduleMapCache(companyId: string): Observable<Array<InventoryScheduleMap>> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/inventorys/cache/update/${companyId}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public updateLocationPinScheduleMapHistory(inventoryId: string, location: Address): Observable<Inventory> {
		const options: any = this.setHeader()

		return this.http
			.patch<any>(`${PATH}/inventorys/updatePin/location/${inventoryId}`, JSON.stringify(location), {
				headers: options
			})
			.pipe(
				map(result => {
					return result
				})
			)
	}

	public cloneInventory(companyId: string, inventoryId: string): Observable<string> {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/inventorys/clone-inventory/${companyId}/${inventoryId}`,
			{
				headers: options
			}).pipe(
				map(res => {
					return res.message
				})
			)
	}

	private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append('x-source-from', 'PAINEL')
	}
}
